import { memo } from 'react';
import { useTheme } from '@mui/material';
import AreasAssignedIllustrationLight from './areasAssigned.svg?react';
import AreasAssignedIllustrationDark from './areasAssigned_dark.svg?react';

export const AreasAssignedIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <AreasAssignedIllustrationDark aria-hidden="true" {...props} />;
    return <AreasAssignedIllustrationLight aria-hidden="true" {...props} />;
  },
);
